import React from "react";
import { Divider, Tag, Timeline, TimelineItemProps, Typography } from "antd";
import { ResumeExperience as ResumeExperienceType } from "../../Entities/UserProfile";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

const formatMonthYear = (dateString: string | null | undefined): string => {
  if (!dateString || dateString.trim() === "") return "";
  const parsed = dayjs(dateString);
  if (!parsed.isValid()) return "";
  return parsed.format("MMM YYYY");
};

const ExperienceItem: React.FC<{
  companyName: string;
  designation: string | null;
  description: string | null;
  from: Date | string | null;
  to: Date | string | null;
}> = ({ companyName, description, designation, from, to }) => {
  const getTagText = () => {
    if (!from && !to) {
      return null;
    } else if (from) {
      if (!to) {
        return `${formatMonthYear(from.toString())} - Present`;
      } else {
        return `${formatMonthYear(from.toString())} - ${formatMonthYear(to.toString())}`;
      }
    } else {
      return null;
    }
  };

  const tagText = getTagText();

  return (
    <div className="experience-item">
      <div className="experience-item-header">
        <div className="experience-item-header-title">
          <Typography.Text strong>{designation}</Typography.Text>
          <Typography.Text
            style={{ display: "flex", alignItems: "center", gap: "4px" }}
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "14px" }}
            >
              apartment
            </span>
            {companyName}
          </Typography.Text>
        </div>
        {tagText && <Tag>{tagText}</Tag>}
      </div>
      <Typography.Paragraph
        type="secondary"
        style={{ fontSize: "13px", fontStyle: "italic", margin: 0 }}
      >
        {description}
      </Typography.Paragraph>
    </div>
  );
};

interface ResumeExperienceProps {
  experience: ResumeExperienceType[];
}

const ResumeExperience: React.FC<ResumeExperienceProps> = ({ experience }) => {
  const items: TimelineItemProps[] = experience.map((e, i) => {
    return {
      key: i,
      children: (
        <ExperienceItem
          key={i}
          companyName={e.companyName}
          designation={e.designation || null}
          description={e.description || null}
          from={e.from || null}
          to={e?.to || null}
        />
      ),
    };
  });

  return (
    <div className="resume-preview-card">
      <div className="resume-preview-card-header">
        <div className="resume-preview-card-header-title">
          <span className="material-symbols-outlined">work_history</span>
          <Typography.Text strong>Professional Experience</Typography.Text>
        </div>
      </div>
      <Divider style={{ margin: 0 }} />
      <Timeline items={items} style={{ width: "100%" }} />
    </div>
  );
};

export default ResumeExperience;
